<!-- TODO: swap for lds-search [future release] -->

<div
  class="form-group"
  [ngClass]="{ 'has-error': hasErrors }"
  [formGroup]="formGroup">
  <!-- label -->
  <lds-label context="{{ name }}" *ngIf="hasLabel" [showIndicator]="isRequired">
    {{ label }}
  </lds-label>

  <div
    class="form-affix-group"
    [ngClass]="{
      'is-disabled': isDisabled,
      'has-error': hasErrors,
      'has-highlight': showHighlight
    }">
    <!-- prefix -->
    <div class="form-input-affix form-input-affix--prefix">
      <div class="affix__icon">
        <lds-icon name="search" size="sm" appearance="inherit"> </lds-icon>
      </div>
    </div>

    <!-- input -->
    <input
      class="form-input"
      [id]="name"
      [name]="name"
      formControlName="search"
      [maxlength]="maxLength"
      [placeholder]="placeholder"
      autocomplete="off"
      container="body"
      [typeahead]="isAsync ? source$ : dataSource"
      [typeaheadAsync]="isAsync"
      [typeaheadWaitMs]="isAsync ? waitMs : 0"
      [typeaheadMinLength]="isAsync ? minLength : 0"
      typeaheadOptionField="label"
      [typeaheadIsFirstItemActive]="isFirstItemActive"
      [optionsListTemplate]="tplSearchResults"
      [typeaheadScrollable]="!isAsync"
      (typeaheadOnSelect)="onSelect($event)"
      (typeaheadOnBlur)="typeaheadOnBlur($event)"
      (blur)="onBlur($event)"
      [ngClass]="{
        'is-disabled': isDisabled,
        'has-highlight': showHighlight
      }" />

    <!-- suffix -->
    <div class="form-input-affix form-input-affix--suffix">
      <div class="affix__icon" [hidden]="!searchInProgress">
        <lds-loader size="xs"> </lds-loader>
      </div>
    </div>
  </div>

  <ng-container *ngIf="hasSearchError">
    <lds-form-feedback [control]="form" [messages]="messages">
    </lds-form-feedback>
  </ng-container>
</div>

<!-- template / results -->
<ng-template
  #tplSearchResults
  let-matches="matches"
  let-query="query"
  let-typeaheadTemplateMethods>
  <div class="search-results">
    <div
      class="search-results__item"
      *ngFor="let match of matches"
      (click)="typeaheadTemplateMethods.selectMatch(match, $event)"
      (mouseenter)="typeaheadTemplateMethods.selectActive(match)">
      <div class="item__label">
        {{ match.item.label }}
      </div>
      <div class="item__subtext" *ngIf="match.item.subtext">
        <div [innerHTML]="match.item.subtext"></div>
      </div>
    </div>
  </div>
</ng-template>
